module.exports = __webpack_public_path__ + "static/media/PTLocationPopup.c15532c4.png";